import { useQuery } from "@apollo/client/react";import moment from "moment";
import { usePersistFilters } from "../../../../hooks/usePersistFilters";
import { useEffect, useState } from "react";
import { adaptEstadosArray, GET_AUTORIZACION_PRECIOS_ESTADOS } from "../../../../data/graphQL/queries/AutCambioPrecio/getEstados";

import { GET_DELEGACIONES_BY_USUARIO } from "../../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";
import { adaptDelegacionReclamosArray, adaptDelegacionWithoutAllArray } from "../../../../adapters/delegacionAdapter";
import { GET_USUARIO_DELEGACION_ORIGEN } from "../../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen";

const userId = sessionStorage.getItem('idUsuario');

export const useGetFilters = (estadoPendienteId) => {
  // const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [delegaciones, setDelegaciones] = useState([]);
  const [estados, setEstados] = useState([]);

  const { filters, handleChangeFilters } = usePersistFilters({
    idDelegacion: 0,
    fechaDesde: null,
    fechaHasta: null,
    idEstado: estadoPendienteId
  }, `AutCambioPrecioFilters`);

  const { data: dataEstados } = useQuery(GET_AUTORIZACION_PRECIOS_ESTADOS);

	useEffect(() => {
		if (!dataEstados) return;
    setEstados(adaptEstadosArray(dataEstados));
	}, [dataEstados]);  

  const { data: delegacionesData } = useQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache',
    variables: { idUsuario: JSON.parse(userId, 10) }
  });

  useEffect(() => {
		if (!delegacionesData) return;
    setDelegaciones(adaptDelegacionReclamosArray(delegacionesData));
	}, [delegacionesData]);  

  const { data: delegacionOrigenData } = useQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache',
    variables: { idUsuario: JSON.parse(userId, 10) }
  });

  useEffect(() => {
		if (!delegacionOrigenData) return;
    if (delegacionOrigenData.usuarioFull.success) {
      const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
      sessionStorage.setItem('delegacionOrigen', deleg);

      if (filters.idDelegacion == 0)
      handleChangeFilters('idDelegacion', deleg);
    }
	}, [delegacionOrigenData]);  

  return {
    filters,
    handleChangeFilters,
    delegaciones,
    estados
  };
};